import {
  type SelectArrayInputProps,
  AutocompleteArrayInput,
  useGetList,
} from "react-admin";

import { MODULE_NAMES } from "@/constants";

export const UserGroupArrayInput = ({
  source,
  format,
}: Pick<SelectArrayInputProps, "source" | "format">) => {
  const { isPending, data, error } = useGetList(MODULE_NAMES.GROUPS);

  if (error) return null;

  return (
    <AutocompleteArrayInput
      isPending={isPending}
      source={source}
      format={format}
      optionValue="@id"
      choices={data ?? []}
      disableCloseOnSelect
    />
  );
};
